import Mascot from "../components/Mascot";

const Mascots = () => {
    return (
      <div>
        BELOM
      </div>
    );
  };
  
  export default Mascots;
  